module.exports = __webpack_public_path__ + "static/media/링크 페이지 제작.ed38d311.jpg";